module.exports = __webpack_public_path__ + "img/video_img5.25108b80.png";